import { serializable, alias, object, list, primitive } from "serializr";
import { AdminFeature } from "../AdminFeature/adminFeature.model";
import { DoctorFeature } from "../DoctorFeature/doctorFeature.model";

export class ScanCenter {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("email", primitive()))
  email?: string;

  @serializable(alias("admin_id", primitive()))
  adminId?: string;

  @serializable(alias("admin_type", primitive()))
  adminType?: string;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("company_name", primitive()))
  companyName?: string;

  @serializable(alias("first_name", primitive()))
  firstName?: string;

  @serializable(alias("last_name", primitive()))
  lastName?: string;

  @serializable(alias("mobile_number", primitive()))
  mobileNumber?: string;

  @serializable(alias("address", primitive()))
  address?: string;

  @serializable(alias("password", primitive()))
  password?: string;

  @serializable(alias("admin_features", list(object(AdminFeature))))
  adminFeatures?: AdminFeature[] = [];


  @serializable(alias("doctor_features", list(object(DoctorFeature))))
  doctorFeatures?: DoctorFeature[] = [];
}
